/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {useTypedSelector} from "helpers/reducers";
import {HallCode} from "types/enums/HallCode";
import {Cookies_status} from "types/enums/Cookies_status";

export const useCookies = () => {
    const cookies = useTypedSelector(state => state.bookingState.cookies);
    const hall = useTypedSelector(state => state.hallState.hall);

    const cookiesEnabledHandler = () => {
        if (!hall) {
            return false;
        }

        if (hall.hall_code === HallCode.ArboPark) {
            return true;
        }
    };

    const cookiesEnabled = cookiesEnabledHandler();

    const showCookiesBannerHandler = () => {
        if (!cookies) {
            return false;
        }
        if (!cookiesEnabled || cookies.status !== Cookies_status.AGREED) {
            return false;
        }
        if (cookiesEnabled && cookies.status !== Cookies_status.AGREED) {
            return true;
        }
    };
    const showCookiesBanner = showCookiesBannerHandler();

    return {
        cookies,
        cookiesEnabled,
        showCookiesBanner,
    };
};
